define('shared/util/validate/validators/chuanr',['shared/lib/validate', 'shared/lib/RSVP'], function (validate, RSVP) {
    'use strict';
    var KEY = 'patterns';

    function validator(value, options){
        return new RSVP.Promise(function(resolve, reject){
            var chuanr = options.chuanr;
            if (chuanr == null)  {
                resolve();
                return;
            }
            if (chuanr.intact()) {
                resolve();
            }
            else {
                reject( options.message || 'The input doesn\'t matches the predefined patterns' );
            }
        });
    }

    // register to validate js
    validate.validators[KEY] = validator;
    validator.KEY = KEY;

    return validator;

});
